import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" id=\"linkedin\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M4.557 5.341v10.507H1.06V5.341h3.498zm.223-3.244c.007.516-.171.947-.535 1.293s-.843.52-1.437.52h-.021c-.58 0-1.046-.174-1.4-.52a1.738 1.738 0 0 1-.53-1.293c0-.524.182-.956.546-1.3.364-.342.84-.514 1.426-.514.587 0 1.057.172 1.41.515.354.343.534.775.541 1.299zm5.195 4.737c.135-.212.273-.399.414-.56a4.52 4.52 0 0 1 .599-.551c.25-.198.558-.352.922-.462.364-.11.77-.164 1.214-.164 1.21 0 2.181.401 2.916 1.204.735.802 1.103 1.977 1.103 3.525v6.022h-3.488v-5.62c0-.741-.144-1.323-.43-1.743-.286-.42-.733-.631-1.341-.631-.445 0-.818.122-1.119.366-.3.243-.524.546-.673.906-.078.212-.117.498-.117.859v5.863H6.487c.014-2.82.021-5.107.021-6.86 0-1.753-.003-2.799-.01-3.138l-.01-.509h3.487v1.493z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkedin.svg
// module id = ./src/assets/img/linkedin.svg
// module chunks = 2